import { UserData, UserLevel } from 'src/State/User/UserModel'
import { UserType, UserTypes } from '../types'
import { isFlowTheme } from 'src/Libs/utils'

/**
 * Based on the given user role and the number of installations different type of users are defined
 * The type influence the overall structure of the app (such as which pages can be accessed)
 *
 * @param userLevel
 * @param installations
 * @returns type of user
 */

export const getUserType = (userLevel: UserLevel, installationCount: number): UserType => {
  const hasMultipleInstallations = installationCount > 1
  const isInstallerOrPartner = userLevel === 'INSTALLER' || userLevel === 'PARTNER'
  const isService =
    userLevel === 'E3DC_SERVICE' || userLevel === 'E3DC_ADMIN' || userLevel === 'E3DC_ROOT' || (isFlowTheme && userLevel === 'EXT_SERVICE_PLUS')
  const isManager = false /* TODO: use new BE flag to identify user as manager */

  if (userLevel === 'USER' && hasMultipleInstallations) {
    return UserTypes.installationOverview
  } else if (userLevel === 'USER') {
    return UserTypes.owner
  } else if (isInstallerOrPartner && isManager) {
    return UserTypes.companyOwner
  } else if (isInstallerOrPartner) {
    return UserTypes.installerPartner
  } else if (isService) {
    return UserTypes.service
  } else {
    return UserTypes.owner /* fallback value */
  }
}

const NAME_SEPARATOR = ' '

/**
 * Constructs a human-readable naming for the given UserData model.
 *
 * The result is either the full name of a user if all data is available, or the username
 *
 * @param value
 */
export const getDisplayName = (value: UserData): string => {
  const fullName = [(value.Vorname || '').trim(), (value.Name || '').trim()].filter(value => value.length > 0)

  if (fullName.length > 0) {
    return fullName.join(NAME_SEPARATOR)
  }

  return value.username
}
